<template>
  <Section class="child-category" wide-mode small-space>
    <div class="head">
      <h2 class="title">{{ title }}</h2>
      <NuxtLink class="link" :to="`/${slug}`">
        Tout voir
        <uikit-chevron-icon class="chevron" type="right" />
      </NuxtLink>
    </div>
    <cms-components-rich-text class="description" :text="description" />

    <article-swipe-container :items="articles">
      <template #item="{ item }">
        <article-card :key="item.id" :article="item" :parent-category-slug="parentCategorySlug" />
      </template>
    </article-swipe-container>
  </Section>
</template>

<script setup>
import { UikitChevronIcon } from '@hz/ui-kit'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  slug: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  articles: {
    type: Array,
    required: true,
  },
})

const parentCategorySlug = computed(() => {
  return props.slug.split('/')[0]
})
</script>

<style lang="less" scoped>
.head {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
}

.title {
  font-weight: var(--ds-weight-semi-bold);
  font-size: 24px;
  color: var(--ds-color-primary-100);
  margin-bottom: 12px;
}

.description {
  font-weight: 400;
  font-size: 14px;
  color: var(--ds-color-gray-50);
  margin-bottom: 24px;
}

.link {
  white-space: nowrap;

  color: var(--ds-color-primary-100);
  font-size: 20px;
  font-weight: var(--ds-weight-semi-bold);
  text-decoration: none !important;

  .chevron {
    height: 17px;
    width: 16px;
    margin-bottom: -2px;
  }
}

:deep(.article-card) {
  margin-left: 32px;

  &:last-child {
    margin-right: 32px;
  }
}
</style>
